export default __webpack_public_path__ + "static/media/rpl6.730f2786.jpg";